import { cn } from "@/lib/utils";
import { CheckIcon } from 'lucide-react';

const FormStepIndicator = ({ currentStep, formType }) => {
   const csawSteps = [
      { number: 1, title: 'Registration Type', description: 'Choose your registration type' },
      { number: 2, title: 'Chainsaw Store', description: 'Enter store details' },
      { number: 3, title: 'Requirements', description: 'Select requirements' },
      { number: 4, title: 'Documents', description: 'Upload documents' },
      { number: 5, title: 'Details', description: 'Fill in details' },
      { number: 6, title: 'Review', description: 'Review application' }
   ];

   const covSteps = [
      { number: 1, title: 'PLTP Verification', description: 'Verify PLTP details' },
      { number: 2, title: 'Application Details', description: 'Fill in application info' },
      { number: 3, title: 'Documents', description: 'Upload required documents' },
      { number: 4, title: 'Additional Documents', description: 'Upload additional files' },
      { number: 5, title: 'Review', description: 'Review application' }
   ];

   const ptprSteps = [
      { number: 1, title: 'Personal Information', description: 'Enter personal details' },
      { number: 2, title: 'Plantation Details', description: 'Enter plantation info' },
      { number: 3, title: 'Document Requirements', description: 'Check requirements' },
      { number: 4, title: 'Upload Documents', description: 'Upload required files' },
      { number: 5, title: 'Review', description: 'Review application' }
   ];

   const pltcpSteps = [
      { number: 1, title: 'Request Type', description: 'Select request type' },
      { number: 2, title: 'Applicant Details', description: 'Enter applicant info' },
      { number: 3, title: 'Tree and Land Details', description: 'Enter property details' },
      { number: 4, title: 'Document Requirements', description: 'Check requirements' },
      { number: 5, title: 'Upload Documents', description: 'Upload required files' },
      { number: 6, title: 'Review', description: 'Review application' }
   ];

   const pltpSteps = [
      { number: 1, title: 'Request Type', description: 'Select request type' },
      { number: 2, title: 'Applicant Details', description: 'Enter applicant info' },
      { number: 3, title: 'Tree and Land Details', description: 'Enter property details' },
      { number: 4, title: 'Document Requirements', description: 'Check requirements' },
      { number: 5, title: 'Upload Documents', description: 'Upload required files' },
      { number: 6, title: 'Review', description: 'Review application' }
   ];

   const tcebpSteps = [
      { number: 1, title: 'Request Type', description: 'Select request type' },
      { number: 2, title: 'Personal Information', description: 'Enter personal details' },
      { number: 3, title: 'Requirements', description: 'Check requirements' },
      { number: 4, title: 'Documents', description: 'Upload documents' },
      { number: 5, title: 'Review', description: 'Review application' }
   ];

   const getSteps = () => {
      switch (formType) {
         case 'COV':
            return covSteps;
         case 'PTPR':
            return ptprSteps;
         case 'PLTCP':
            return pltcpSteps;
         case 'PLTP':
            return pltpSteps;
         case 'TCEBP':
            return tcebpSteps;
         default:
            return csawSteps;
      }
   };

   const steps = getSteps();

   return (
      <div className="w-full py-4 overflow-x-auto">
         <div className="flex justify-between items-start min-w-[500px] px-4">
            {steps.map((step, index) => (
               <div
                  key={step.number}
                  className={cn(
                     "relative flex flex-col items-center flex-1",
                     index !== steps.length - 1 && "after:content-[''] after:absolute after:top-[22px] after:left-1/2 after:w-full after:h-[2px] after:transition-colors after:duration-300",
                     index !== steps.length - 1 && currentStep > step.number
                        ? "after:bg-green-600 dark:after:bg-green-500"
                        : "after:bg-gray-200 dark:after:bg-gray-700"
                  )}
               >
                  {/* Step Circle */}
                  <div className="relative z-10 flex items-center justify-center">
                     <div
                        className={cn(
                           "w-11 h-11 rounded-full flex items-center justify-center transition-all duration-300",
                           currentStep >= step.number
                              ? "bg-green-600 dark:bg-green-500"
                              : "bg-gray-200 dark:bg-gray-700"
                        )}
                     >
                        {currentStep > step.number ? (
                           <CheckIcon className="w-5 h-5 text-white" />
                        ) : (
                           <span className={cn(
                              "text-sm font-medium",
                              currentStep >= step.number
                                 ? "text-white"
                                 : "text-gray-500 dark:text-gray-400"
                           )}>
                              {step.number}
                           </span>
                        )}
                     </div>
                  </div>

                  {/* Step Title and Description */}
                  <div className="mt-3 flex flex-col items-center text-center">
                     <span className={cn(
                        "text-sm font-medium mb-1 transition-colors duration-300",
                        currentStep >= step.number
                           ? "text-green-600 dark:text-green-500"
                           : "text-gray-500 dark:text-gray-400"
                     )}>
                        {step.title}
                     </span>
                     <span className="text-xs text-gray-400 dark:text-gray-500 hidden sm:block">
                        {step.description}
                     </span>
                  </div>
               </div>
            ))}
         </div>
      </div>
   );
};

export default FormStepIndicator;
